/**
 * The main JavaScript file to be used on the Front End.
 * Remove and add files as the project requires.
 */

// Helpers.
import './helpers/debounce';
import './helpers/get-ancestor-nodes';
import './helpers/is-touch';
import './helpers/rem-px';

// Project files.
import './src/lazyload';
import './src/skip-link-focus';
import './src/smooth-scroller';
import './src/iframe-fix';

// Functionality.
import './src/cookie-control';
import './src/language-switcher';
import './src/terra-archive';
import './src/google-maps';
import './src/video-players';
import './src/pagination';
import './src/utm-cookies';
import './src/g01-header';
import './src/g02-search-dropdown';
import './src/g03-footer';
import './src/m03-logo-slider';
import './src/m04-service-types';
import './src/m06-case-studies';
import './src/m07-posts-feed';
import './src/m08-testimonials';
import './src/m10-services';
import './src/m13-more-services';
import './src/m17-slider';
import './src/m18-vacancies';
import './src/m28-publications';
import './src/m32-contact-info';
import './src/m46-images-slider';
import './src/m47-single-path';
import './src/m47b-multiple-paths';
import './src/m49-vacancies-slider';
import './src/m50-background-slider';
import './src/m51-embed-grid';
import './src/m52-popup';
